<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>编辑跟卖数据</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
      >
        <el-form-item
            label="监控人"
            prop="offerUserIds"
            :rules="[
              { required: true, message: '请选择监控人', trigger: ['change', 'blur'] }
            ]"
            label-width="60px">
          <gj-select
              v-model="form.offerUserIds"
              :options="active ? activeUserOptions : userOptions"
              multiple
              width="400px"
              @change="selectMonitor"
              :clearable="false">
          </gj-select>

        </el-form-item>
        <el-form-item
            style="margin-bottom: 0"
            label="排除店铺"
            prop="exceptSellerIds"
            label-width="60px">
          <gj-textarea
              v-model="form.exceptSellerIds"
              width="400px"
              placeholder="请输入排除店铺的Seller ID（默认排除对接到系统的店铺）；如有多个，请使用换行隔开；请勿输入其他字符或空行"
              :autosize="{ minRows: 4 }"
          >
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import {formValidatorMixin, modalMixIn, responseMixin} from "@/minxins";
import {editFollowItem} from "@/api/tool";
import {mapGetters} from "vuex";
import {USER_GET_ACTIVE_USER_OPTIONS, USER_GET_USER_OPTIONS} from "@/store/action-types";
import _ from "lodash";

export default {
  name: "edit-follow-up-item",
  mixins: [modalMixIn, formValidatorMixin, responseMixin],
  props:{
    id:{
      type: String
    },
    row:{
      type: Object
    }
  },
  data() {
    return {
      confirmLoading: false,
      active: false,
      form: {
        offerUserIds: [],
        exceptSellerIds: null
      }
    }
  },
  computed:{
    ...mapGetters({
      userOptions: 'userOptions',
      activeUserOptions: 'activeUserOptions'
    }),
  },
  created() {
    if (this.active) {
      if (this._.isEmpty(this.activeUserOptions)) {
        this.$store.dispatch(USER_GET_ACTIVE_USER_OPTIONS);
      }
    } else {
      if (this._.isEmpty(this.userOptions)) {
        this.$store.dispatch(USER_GET_USER_OPTIONS);
      }
    }
    //排除sellerId换行
    let str ="";
    if(this.row && !_.isEmpty(this.row.exceptSellerId)){
      _.map(this.row.exceptSellerIds, p=>{
        str += p + '\n';
      })
      this.form.exceptSellerIds = str;
    }
    if(!_.isEmpty(this.row) && _.isArray(this.row.offerUserNames)){
      let offerUserIds = [];
      _.map(this.row.offerUserNames, v=>{
        let item = _.find(this.userOptions, o=>o.text === v);
        if(!_.isEmpty(item)){
          offerUserIds.push(item.id);
        }
      })
      this.form.offerUserIds = offerUserIds;
    }
  },
  methods: {
    selectMonitor(){

    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const ids = [this.id];
          this.form.ids = ids;
          this.form.exceptSellerIds = this.form.exceptSellerIds ? this.form.exceptSellerIds.split(/[\s\n]/) : [];
          editFollowItem(this.form).then((res)=>{
            this.$gjResponseHandle(res, () => {
              this.$emit('edited');
              this.$gjDestroy();
            });
          }).complete(() => this.confirmLoading = false);
        }
      });
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog__body{
  padding-bottom: 0;
}
</style>
